import React, { useState, useEffect } from 'react'
import DropDownList from '../../components/DropDownList'
import styles from './MapOptions.module.scss'
import { useGeoFetch, useGeoState } from '../../components/GeoProvider'

const Filters = () => {  
 const [filtersDropdown, setFiltersData] = useState()
   const { getRefreshDateFilter, getStateFilter, getAgeGroupFilter, getGenderFilter,
       getVaccineTypeFilter,setRefreshDateFilter,setStateFilter,setAgeGroupFilter,setGenderFilter, setVaccineTypeFilter } =
       useGeoState()

  const { data: filtersData, error: filtersDataError } = useGeoFetch(
    '',
    '',
    'meningitisFilters',
    '', false,{},'POST'
  )

  useEffect(() => {
    if (filtersData !== null && filtersData !== undefined) {
      setFiltersData(filtersData.response_data)
    }
  }, [filtersData])
  
 const ResetFilters = (event) => {
    setStateFilter('All');
    setAgeGroupFilter('All');
    setGenderFilter('All');
    setRefreshDateFilter('1991-01-01');
    setVaccineTypeFilter('All')
  }

  return (
    <div className={styles.base}>
      {filtersDropdown && filtersDropdown.refresh_date && <div  className={styles.pageDiseaseList}> 
        <p>Refresh Date</p>
          <DropDownList
            id="refreshDate"
             onChange={(e) => {
            setRefreshDateFilter(e.target.value)
          }}
          className={styles.dropDowns}
          value={getRefreshDateFilter}
          >
            {filtersDropdown.refresh_date.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>

        </div>}
      {filtersDropdown && filtersDropdown.state && <div  className={styles.pageDiseaseList}> 
        <p>State</p>
          <DropDownList
            id="state"
             onChange={(e) => {
            setStateFilter(e.target.value)
          }}
          className={styles.dropDowns}
          value={getStateFilter}
          >
            {filtersDropdown.state.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>

        </div>}
        {filtersDropdown && filtersDropdown.age_group && <div  className={styles.pageDiseaseList}> 
          <p>Age Group</p>
          <DropDownList
            id="ageGroup"
             onChange={(e) => {
            setAgeGroupFilter(e.target.value)
          }}
          className={styles.dropDowns}
          value={getAgeGroupFilter}
          >
            {filtersDropdown.age_group.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>


        </div>}
        {filtersDropdown && filtersDropdown.gender && <div  className={styles.pageDiseaseList}> 
          <p>Gender</p>
          <DropDownList
            id="gender"
             onChange={(e) => {
            setGenderFilter(e.target.value)
          }}
             className={styles.dropDowns}
              value={getGenderFilter}
          >
            {filtersDropdown.gender.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>
        </div>}
        {filtersDropdown && filtersDropdown.vaccine_type && <div  className={styles.pageDiseaseList}> 
            <p>Vaccine Type</p>
           <DropDownList
            id="vaccineType"
             onChange={(e) => {
            setVaccineTypeFilter(e.target.value)
          }}
          className={styles.dropDowns}
          value={getVaccineTypeFilter}
          >
            {filtersDropdown.vaccine_type.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>
        </div>}
        <button className={styles.buttonClass} onClick={ResetFilters}>Reset Filter</button>
    </div>
  )
}

export default Filters
